import { VOICE_RECORDING_STARTED, VOICE_WAVEFORM_DATA, VOICE_MIC_PERMISSION_ERROR } from '../iframe-communication/constants/sentPostMessageTypes';
const WAVEFORM_INTERVAL_MS = 75;

// Compute RMS from time-domain bytes where 128 is the zero crossing point
function calculateRmsLevel(analyser) {
  const bufferLength = analyser.fftSize;
  const dataArray = new Uint8Array(bufferLength);
  analyser.getByteTimeDomainData(dataArray);
  let sum = 0;
  for (let i = 0; i < bufferLength; i++) {
    const normalized = (dataArray[i] - 128) / 128;
    sum += normalized * normalized;
  }
  return Math.min(1, Math.sqrt(sum / bufferLength));
}
export class VoiceRecorderPlugin {
  constructor(widgetShell) {
    this.stream = null;
    this.recorder = null;
    this.audioContext = null;
    this.analyser = null;
    this.waveformTimer = null;
    this.handleVoiceRecordingRequest = async () => {
      try {
        if (typeof MediaRecorder === 'undefined') {
          this.widgetShell.iframeMessage.post(VOICE_MIC_PERMISSION_ERROR);
          return;
        }
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            channelCount: 1
          }
        });
        this.startRecording();
        this.widgetShell.iframeMessage.post(VOICE_RECORDING_STARTED);
      } catch (_e) {
        this.cleanup();
        this.widgetShell.iframeMessage.post(VOICE_MIC_PERMISSION_ERROR);
      }
    };
    this.handleVoiceRecordingConfirm = () => {
      this.cleanup();
    };
    this.handleVoiceRecordingDiscard = () => {
      this.cleanup();
    };
    this.widgetShell = widgetShell;
  }
  startRecording() {
    if (!this.stream) return;
    this.setupAnalyser(this.stream);
    this.startWaveformStreaming();

    // eslint-disable-next-line compat/compat
    this.recorder = new MediaRecorder(this.stream);
    this.recorder.start();
  }
  setupAnalyser(stream) {
    // eslint-disable-next-line compat/compat
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) {
      throw new Error('AudioContext is not supported in this browser');
    }
    this.audioContext = new AudioContextClass();
    if (this.audioContext.state === 'suspended') {
      void this.audioContext.resume();
    }
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 2048;
    const source = this.audioContext.createMediaStreamSource(stream);
    source.connect(this.analyser);
  }
  startWaveformStreaming() {
    this.waveformTimer = setInterval(() => {
      if (!this.analyser) return;
      this.widgetShell.iframeMessage.post(VOICE_WAVEFORM_DATA, {
        level: calculateRmsLevel(this.analyser)
      });
    }, WAVEFORM_INTERVAL_MS);
  }
  cleanup() {
    if (this.waveformTimer) {
      clearInterval(this.waveformTimer);
      this.waveformTimer = null;
    }
    if (this.recorder && this.recorder.state !== 'inactive') {
      this.recorder.stop();
    }
    this.recorder = null;
    if (this.audioContext && this.audioContext.state !== 'closed') {
      void this.audioContext.close();
    }
    this.audioContext = null;
    this.analyser = null;
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }
}